import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.labels')
  .factory('LabelsAPI', LabelsAPI);

function LabelsAPI(): BringozApi {
  return {
    base: `/labels`,
    infiniteScroll: {
      address: `/labels`,
      cmd: 'GET'
    },
    actions: {
      getAll: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      createOne: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateOne: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      }
    }
  }
}
